enum HeadingColor {
    light = 'light',
    dark = 'dark',
    extra = 'extra',
    contrast = 'contrast',
}

export default HeadingColor
